import _ from "lodash";
import LayoutUtils from "./LayoutUtils";

class StackLayoutStrategy {
  constructor(/** Object **/ config = {}) {
    this.config = config;
    this.maxWidth = _.get(this.config, "maxWidth", 320);
    this.elementMinWidth = _.get(this.config, "elementMinWidth", 100);
    this.yPadding = _.get(this.config, "yPadding", 10);
  }

  apply(/** ElementGroup **/ group) {
    let maxWidth = this.maxWidth;
    let minElemWidth = this.elementMinWidth;
    let yPadding = this.yPadding;

    let numElements = group.elements.length;

    group.width = Math.min(group.bounds.w, maxWidth);
    if (numElements == 1) {
      group.width = Math.max(minElemWidth, group.width);
    }

    let widthScale = group.width / group.bounds.w;

    group.elements.sort(this._elementSort);

    group.height = 0;

    _.each(group.elements, function (elementData) {
      let localRect = _.get(elementData, "localRect");
      let aspectRatio = localRect.h / localRect.w;

      localRect.w = Math.max(
        minElemWidth,
        Math.min(maxWidth, Math.round(widthScale * localRect.w))
      );
      localRect.h = Math.round(aspectRatio * localRect.w);

      localRect.x = 0;
      localRect.y = group.height;

      localRect.x2 = localRect.x + localRect.w;
      localRect.y2 = localRect.y + localRect.h;

      group.height = localRect.y2 + yPadding;
    });
  }

  _elementSort(a, b) {
    let boundsA = a.localRect;
    let boundsB = b.localRect;

    if (boundsA.y == boundsB.y) return boundsB.x - boundsB.x;

    return boundsA.y - boundsB.y;
  }
}

export default StackLayoutStrategy;
